import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Report, ReportQueryParams } from '../models/report.model';
import { ListResponse } from '../models/utility.model';
import { ReportGateway } from '../usecases/report.gateway';

@Injectable()
export class ReportService extends ReportGateway {
  constructor(private _http: HttpClient) {
    super();
  }

  listReports(params: ReportQueryParams): Observable<ListResponse<Report>> {
    const { projectId } = params;
    return this._http.get<ListResponse<Report>>(`api/vgs/projects/${projectId}/reports`, { params });
  }

  getReport(projectId: string, version: number): Observable<{ url: string }> {
    return this._http.get<{ url: string }>(`api/vgs/projects/${projectId}/reports/${version}`);
  }
}
